import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { AppState } from '../reducers/rootReducer';

const _selectCurrentUser = (state: AppState) => state.Auth.currentUser;

export const selectCurrentUser = createDraftSafeSelector(_selectCurrentUser, payload => payload);
